<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.reported_users") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-search"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Search</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            placeholder="Name"
            icon-no-border
            label="Name"
            v-model="name"
            @keyup.delete="getAllReportedUsers()"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            placeholder="Email"
            icon-no-border
            label="Email"
            v-model="email"
            @keyup.delete="getAllReportedUsers()"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            color="success"
            class="mr-3 mb-2"
            @click="getAllReportedUsers()"
            >Search</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="closeForm()"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table :max-items="perPage" stripe :data="users">
        <template slot="thead">
          <vs-th>{{ $t("labels.profile_pic") }}</vs-th>
          <vs-th>{{ $t("labels.name") }}</vs-th>
          <vs-th>{{ $t("labels.reason") }}</vs-th>
          <vs-th>{{ $t("labels.email") }}</vs-th>
          <vs-th>{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].profile_pic" style="width:15% !important;">
               <vs-avatar
                class="mx-auto"
                size="100px"
                :src="data[indextr].profile_pic"
              />
                <!-- <img v-bind:src="data[indextr].profile_pic" /> -->
              <!-- <img v-bind:src="data[indextr].user_data.profile_pic" /> -->
            </vs-td>

            <vs-td class="word-break" style="width:15% !important;"  :data="data[indextr].name">
              {{ data[indextr].name | upper }}
            </vs-td>

            <vs-td class="word-break" style="width:40% !important;"  :data="data[indextr].reason">
              {{ data[indextr].reason }}
            </vs-td>

            <vs-td :data="data[indextr].email" style="width:15% !important;">
              {{ data[indextr].email }}
            </vs-td>
            <vs-td :data="data[indextr].email" style="width:10% !important;">
              <span>
                <vs-button
                  title="View"
                  class="m-1 float-left"
                  size="small"
                  color="success"
                  icon="icon-eye"
                  icon-pack="feather"
                  @click="showDetailedPage(data[indextr].user_id)"
                ></vs-button>
                <vs-button
                  title="Delete"
                  class="m-1 float-left"
                  size="small"
                  color="danger"
                  icon="icon-trash-2"
                  @click.native="DeleteAccount(data[indextr].id)"
                  icon-pack="feather"
                ></vs-button>
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="float-right mt-5">
      <vs-pagination
        ref="paginationApplication"
        :total="totalPage"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    mode: "",
    interest: "",
    name: "",
    email: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
    interest_search: "",
    mode_search: "",
    routerName: "StudentsById",
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllReportedUsers();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllReportedUsers();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllReportedUsers();
      }
    },
  },
  methods: {
    showDetailedPage(id) {
      this.$router.push({ name: this.routerName, params: { id: id } });
    },
    getAllReportedUsers() {
      if (this.interest) {
        this.interest_search = this.interest.id;
      } else {
        this.interest_search = "";
      }
      if (this.mode) {
        this.mode_search = this.mode.id;
      } else {
        this.mode_search = "";
      }
      let input = {
        name: this.name,
        email: this.email,
        page: this.currentPage,
        perPage: this.perPage,
      };
      console.log(input);
      axios
        .post("admin/reportedUsers", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.reported_users;
          if (data.reported_users.role == "T") {
            this.routerName = "TeachersById";
          }
          if (data.count < this.perPage) {
            this.currentPage = 1;
          }
          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.email = ""), (this.name = ""), this.getAllReportedUsers();
    },
    closeForm() {
      this.data_hide = !this.data_hide;
    },
    DeleteAccount(id) {
      this.deleteID = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("labels.delete_reported_user"),
        text: this.$t("strings.delete_reported_user"),
        acceptText: this.$t("labels.delete_button"),
        accept: this.deleteUser,
      });
    },
    deleteUser() {
      axios
        .get("admin/deleteInquiry/" + this.deleteID)
        .then((response) => {
          let data = response.data;
          this.getAllReportedUsers();
          this.$vs.notify({
            text: "Reported user deleted successfully",
            color: "success",
            position: "top-right",
          });

          this.deleteID = null;
        })
        .catch((e) => {
          this.deleteID = null;
          this.showError(e);
        });
    },
  },
  mounted() {
    this.getAllReportedUsers();
  },
};
</script>

<style lang="scss" scoped>
</style>